import React from 'react';
import styled from 'styled-components';

import { ProductCardTextAlignmentOption } from 'types/graphql';
import { ProductCard } from 'src/dispensary-admin/components/product-card';
import { PreviewData } from '../components/preview';

type ProductCardPreviewProps = {
  data: PreviewData;
  showMobileAppPreview?: boolean;
};

export const ProductCardPreview = ({ data, showMobileAppPreview = false }: ProductCardPreviewProps): JSX.Element => {
  const { textAlignment, showProductWeight, mobileAppDisplayOptions } = data.productCards;

  let cardImage = '';

  if (textAlignment === ProductCardTextAlignmentOption.center) {
    cardImage = showProductWeight ? 'card-preview-weight-center.png' : 'card-preview-no-weight-center.png';
  } else {
    cardImage = showProductWeight ? 'card-preview-weight-v2.png' : 'card-preview-no-weight.png';
  }

  return (
    <Container>
      <figure>
        <Caption>Card View</Caption>
        <Image src={`https://images.dutchie.com/product-cards/${cardImage}`} alt='Card View Preview' width={184} />
      </figure>
      <figure>
        <Caption>List View</Caption>
        <Image src='https://images.dutchie.com/product-cards/list-preview-v2.png' alt='List View Preview' width={346} />
      </figure>

      {showMobileAppPreview && (
        <figure>
          <Caption>Mobile App Card View</Caption>
          <MobilePreview>
            <MobileCard>
              <ProductCard
                isFullHeight={false}
                product={{
                  Name: 'Blue Dream',
                  Prices: [35],
                  Options: ['1g'],
                  brand: { name: 'Dutchie' },
                  type: 'Flower Collection',
                  strainType: 'Hybrid',
                  effects: ['Relaxed'],
                  specialNames: ['Buy More Save More', 'Member Deal'],
                  thcContent: { unit: 'PERCENTAGE', range: [22.1] },
                  cbdContent: { unit: 'PERCENTAGE', range: [0.25] },
                }}
                displayOptions={{
                  ...mobileAppDisplayOptions,
                  showProductWeight: mobileAppDisplayOptions.showProductWeight ?? showProductWeight,
                }}
              />
            </MobileCard>
          </MobilePreview>
        </figure>
      )}
    </Container>
  );
};

const Container = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 32px;
  width: 100%;
`;

const Image = styled.img`
  display: block;
  max-width: 100%;
  height: auto;
`;

const Caption = styled.figcaption`
  font-size: 12px;
  line-height: ${18 / 12};
  margin-bottom: 8px;
  text-align: center;
`;

const MobilePreview = styled.div`
  align-items: center;
  background: #f5f8fa;
  border: 1px solid #e3e7e9;
  border-radius: 20px;
  display: flex;
  justify-content: center;
  padding: 12px;
  width: 100%;
`;

const MobileCard = styled.div`
  width: 220px;
`;
